<nav class="cabecera">
    <a class="regresar"><i class="fa fa-chevron-left" (click)="regresar()"></i></a>
    <h5>Agregar corral</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<div class="container">
    <p>&nbsp;</p>
    <div class="row">
        <div class="input-field col s12">
          <input disabled value="{{ lote }}" id="lote" type="text" class="validate">
          <label for="lote" class="active">Lote</label>
        </div>
        <div class="input-field col s12">
            <input id="nombre" name="nombre" type="text" #nombre class="validate">
            <label for="nombre">Nombre</label>
        </div>
        <div class="col s12">
            <button class="btn waves-effect waves-light btn-large agregar-corral" type="button" *ngIf="btnGuardar" (click)="registrar()">Registrar</button>
        </div>
        <div class="col s12">
            <button class="btn waves-effect waves-light btn-large cancelar" type="button" (click)="confirm('¿Seguro que deseas cancelar el registro?')">Cancelar</button>
        </div>
    </div>
</div>

<!-- Modal Structure -->
<div id="modal1" class="modal">
    <div class="modal-content">
        <h4>{{ alert_message }}</h4>
    </div>
    <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat" (click)="close()">Cerrar</a>
    </div>
</div>
<div id="modal2" class="modal confirm">
    <div class="modal-content">
        <h4>{{ confirm_message }}</h4>
    </div>
    <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat confirmar" (click)="confirmar()">Confirmar</a>
        <a class="modal-close waves-effect waves-green btn-flat" (click)="close()">Cerrar</a>
    </div>
</div>
